import { createFileRoute } from "@tanstack/react-router";
import Blog from "@/pages/Blog";
import { fetchBlogList } from "@/lib/blogQueries";
import { buildHead, SITE_URL } from "@/components/SEO";

export const Route = createFileRoute("/blog/")({
  loader: async () => ({ posts: await fetchBlogList() }),
  head: () =>
    buildHead({
      path: "/blog",
      breadcrumbs: [
        { name: "Home", url: SITE_URL },
        { name: "Blog", url: `${SITE_URL}/blog` },
      ],
    }),
  component: Blog,
});
